import { parseAsInteger, useQueryState } from 'nuqs';
import { createContext, useMemo, useState } from 'react';
import { PatientFilters } from '@/types/patients/filters';

export const DEFAULT_FILTERS: PatientFilters = {
  status: '*' as string | null,
  dateOfBirthYear: null as string | null,
  dateOfBirth: null as string | null,
  sex: '*' as string | null,
  subjectHumanReadableId: null as string | null,
  externalId: null as string | null,
  name: null as string | null,
  protocolId: '*' as string | null,
  siteId: null as string | null,
};

export interface TPatientsContext {
  page: number;
  setPage: (page: number) => Promise<URLSearchParams>;
  activeFilters: PatientFilters;
  setActiveFilters: (filters: PatientFilters) => void;
}

export const PatientsContext = createContext<TPatientsContext>(
  {} as TPatientsContext,
);

export type TPatientsInitialData = Omit<
  TPatientsContext, 'setPage' | 'setActiveFilters'
>;

export const QueryStateKey = 'p_page';

export function PatientsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [ page, setPage ] = useQueryState(QueryStateKey, parseAsInteger.withDefault(1).withOptions({
    history: 'push',
  }));
  const [ activeFilters, setActiveFilters ] = useState<PatientFilters>(DEFAULT_FILTERS);

  const value = useMemo(() => {
    return { page, setPage, activeFilters, setActiveFilters };
  }, [ page, setPage, activeFilters, setActiveFilters ]);

  return (
    <PatientsContext.Provider value={ value }>
      { children }
    </PatientsContext.Provider>
  );
}
